import styled from '@emotion/styled'
import { Box, IconButton } from '@material-ui/core'
import { RouteContainer } from 'components/layout/RouteContainer/RouteContainer'

const ScreenContainer = styled(RouteContainer)({
  display: 'flex',
  padding: 0,
})

const Main = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minWidth: 0,
})

const Body = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
})

const ScrollToBottomButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: theme.spacing(2),
  transform: 'translateX(-50%)',
  width: theme.spacing(5),
  height: theme.spacing(5),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.primary.main,
  boxShadow: theme.shadows[3],
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
}))

const ComposerWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$hasMessages'
})<{ $hasMessages: boolean }>(({ theme, $hasMessages }) => ({
  flexShrink: 0,
  padding: theme.spacing(3),
  width: '100%',
  maxWidth: '50%',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  ...(!$hasMessages && {
    height: '100%',
    paddingBottom: '20vh',
  }),
}))

export {
  ScreenContainer,
  Main,
  Body,
  ScrollToBottomButton,
  ComposerWrapper,
}
